const SECOND = 1 * 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export interface GetDaysSinceDateStringParams {
    dateString: string;
}
export const getDaysSinceDateString = ({ dateString }: GetDaysSinceDateStringParams) => {
    const targetDate = new Date(dateString).getTime();
    const now = Date.now();
    const daysSinceOrder = Math.floor((now - targetDate) / DAY);
    return daysSinceOrder;
};
